import type { Scope } from "@sentry/browser";

function getSentry(): Promise<Scope> {
  return new Promise((resolve) => {
    if (window.fandomSentry) {
      resolve(window.fandomSentry);
    } else {
      window.addEventListener("fandomSentryLoaded", () => {
        resolve(window.fandomSentry!);
      });
    }
  });
}

export async function reportError(error: unknown) {
  const sentry = await getSentry();
  sentry.captureException(error);
}
